export const T = {
  en_GB: {
    addTeam: "Add Team",
    editTeam: "Edit team",
    addDescription: "Name the team and choose its members.",
    editDescription: "Change the team's name or members.",
    name: "Name",
    namePlaceholder: "e.g. VIP clients",
    members: "Members",
    membersPlaceholder: "Select members",
    membersSelected: (n: string) => `${n} selected`,
    pickerTitle: "Select members",
    search: "Search users",
    noOptionsFound: "No users found",
    cancel: "Cancel",
    save: "Save",
    duplicate: "A team with this name already exists",
    failedToSave: "Failed to save team",
    added: "Team added",
    saved: "Saved",
  },
  nb_NO: {
    addTeam: "Legg til team",
    editTeam: "Rediger team",
    addDescription: "Gi teamet et navn og velg medlemmer.",
    editDescription: "Endre teamets navn eller medlemmer.",
    name: "Navn",
    namePlaceholder: "f.eks. VIP-kunder",
    members: "Medlemmer",
    membersPlaceholder: "Velg medlemmer",
    membersSelected: (n: string) => `${n} valgt`,
    pickerTitle: "Velg medlemmer",
    search: "Søk etter brukere",
    noOptionsFound: "Ingen brukere funnet",
    cancel: "Avbryt",
    save: "Lagre",
    duplicate: "Et team med dette navnet finnes allerede",
    failedToSave: "Kunne ikke lagre teamet",
    added: "Team lagt til",
    saved: "Lagret",
  },
} as const;
